/**
 * Side Navigation Initialization
 * This module ensures the side navigation is mounted on all pages
 */

import { createNavigation } from '../components/navigation/Navigation.js';
import './seoPageLocale.js';

let isInitializing = false;

const initSideNav = async () => {
    // Prevent double initialization
    if (isInitializing) return;
    isInitializing = true;

    // Check if mount point or navigation container already exists
    const mountPoint = document.getElementById('side-nav-mount');
    const navContainer = document.getElementById('side-navigation-container');
    
    if (mountPoint || navContainer) {
        console.log('[SideNav] Navigation already exists or mounting, skipping');
        return;
    }
    
    // Create mount point and append to body
    const newMountPoint = document.createElement('div');
    newMountPoint.id = 'side-nav-mount';
    newMountPoint.style.position = 'relative';
    document.body.prepend(newMountPoint);
    
    // Initialize the navigation component
    try {
        const navigation = createNavigation(newMountPoint);
        await navigation.init();

        console.log('[SideNav] Side navigation initialized successfully');
        return navigation;
    } catch (error) {
        console.error('[SideNav] Failed to initialize side navigation:', error);
        return null;
    } finally {
        isInitializing = false;
    }
};

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSideNav);
} else {
    initSideNav();
}

export { initSideNav };
export default initSideNav;

